import { render, staticRenderFns } from "./ProfileSettings.vue?vue&type=template&id=4a821d6c&scoped=true&"
import script from "./ProfileSettings.vue?vue&type=script&lang=js&"
export * from "./ProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettings.vue?vue&type=style&index=0&id=4a821d6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a821d6c",
  null
  
)

export default component.exports